import { render, staticRenderFns } from "./AddUsersModal.vue?vue&type=template&id=b5b09182&scoped=true"
import script from "./AddUsersModal.vue?vue&type=script&lang=js"
export * from "./AddUsersModal.vue?vue&type=script&lang=js"
import style0 from "./AddUsersModal.vue?vue&type=style&index=0&id=b5b09182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b09182",
  null
  
)

export default component.exports